var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"x-small":"","icon":""},on:{"click":function($event){$event.stopPropagation();return (function (e) { return _vm.select(_vm.selection); })($event)}}},[_c('v-icon',{style:(_vm.iconColor)},[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }